export default {"src":"/_next/static/media/w_youtube.4f92db28.svg","height":42,"width":42,"blurWidth":0,"blurHeight":0};